module.exports = __webpack_public_path__ + "static/media/note-6.8db6776b.jpg";